/**
 * Full-page loading state for the drops list.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';

import { LoadingSpinner } from '@/components/ui';

import { getDropsLoadingMessage } from '@/features/drops/utils/loading';

interface DropsLoadingPanelProps {
  fetchLength: number;
  fetchedFrom: string;
  fetchedTo: string;
  slowLoading: boolean;
  variant?: 'drops' | 'deployed';
  className?: string;
}

export const DropsLoadingPanel: FC<DropsLoadingPanelProps> = ({
  fetchLength,
  fetchedFrom,
  fetchedTo,
  slowLoading,
  variant = 'drops',
  className,
}) => {
  const { title, detail } = getDropsLoadingMessage({
    fetchLength,
    fetchedFrom,
    fetchedTo,
    slowLoading,
    variant,
  });

  return (
    <div className={className}>
      <div className="flex flex-col items-center text-center max-w-lg px-4">
        <LoadingSpinner size="lg" className="mx-auto" />
        <p className="text-sm text-muted-foreground mt-3">{title}</p>
        {detail ? (
          <p className="text-xs text-muted-foreground mt-2 leading-relaxed">{detail}</p>
        ) : null}
      </div>
    </div>
  );
};

export default DropsLoadingPanel;
